import { authenticatedRequest } from '@app/rest/rest.lib'

import type {
  IEntry,
  IInstrument,
  IInstrumentMetadata,
} from './instrument.interface'
import type { Question } from './types'

export type IGetInstrumentMetadataResponse = {
  metadata: IInstrumentMetadata[]
}

export type IGetInstrumentsResponse = {
  status: string
  instruments: IInstrument[]
}

export type IGetInstrumentResponsesResponse = {
  status: string
  entries: IEntry[]
}

export type IGetInstrumentResponse = {
  instrument: IInstrument
}

export type IGetQuestionsResponse = {
  questions: Question[]
}

export type ICreateQuestionResponse = {
  question: Question
  status: string
}

export type IGetInstrumentStatusResponse = {
  instrumentId: string
  latestVersion: number
}

export function getInstruments() {
  const url = '/api/v2/instruments'

  return authenticatedRequest<IGetInstrumentsResponse>({
    method: 'get',
    url,
  })
}

export function getInstrumentStatus(instrumentId: string) {
  const url = `/api/v2/instrument/${instrumentId}`

  return authenticatedRequest<IGetInstrumentStatusResponse>({
    method: 'get',
    url,
  })
}

export function getInstrumentsForPatient(patientId: string) {
  const url = `/api/v2/patient/${patientId}/instruments`

  return authenticatedRequest<IGetInstrumentMetadataResponse>({
    method: 'get',
    url,
  })
}

export function getInstrumentResponsesForPatient(
  patientId: string,
  instrumentId: string,
  instrumentVersion?: number,
) {
  const params = instrumentVersion >= 0 ? `?version=${instrumentVersion}` : ''
  const url = `/api/v2/patient/${patientId}/instrument/${instrumentId}/responses${params}`

  return authenticatedRequest<IGetInstrumentResponsesResponse>({
    method: 'get',
    url,
  })
}

export function getInstrument(
  instrumentId: string,
  instrumentVersion?: number,
) {
  const params = instrumentVersion >= 0 ? `?version=${instrumentVersion}` : ''
  const url = `/api/v2/instrument/${instrumentId}${params}`

  return authenticatedRequest<IGetInstrumentResponse>({
    method: 'get',
    url,
  })
}

export function getQuestions(instrumentId: string, instrumentVersion: number) {
  const params = instrumentVersion >= 0 ? `?version=${instrumentVersion}` : ''
  const url = `/api/v2/instrument/${instrumentId}/questions${params}`

  return authenticatedRequest<IGetQuestionsResponse>({
    method: 'get',
    url,
  })
}
